<div *ngIf="show">
	<div (click)="openMatDialog()" *ngIf="isClosed" class="bubble">
		<img src="assets/icons/Group%2014573.svg" alt="open" />
	</div>
</div>
